<template>
  <div class="choose__scaling">
    <select v-model="scaleBehaviour" name="scaleBehaviour" v-on:change="onValueChanged">
        <option value="linear">linear</option>
        <option value="responsive">responsive</option>
    </select>
  </div>
</template>

<script>
export default {
  name: "chooseScaleBehaviour",
  props: ["modelItem"],
  created() {
    console.log("chooseScaleBehaviour created");
    this.init();
  },
  components: {},
  data() {
    return {
      scaleBehaviour: null,
      value: null
    };
  },
  watch: {
    "modelItem.value": "init"
  },
  methods: {
    init() {
      let val = this.modelItem.value || {};
      this.scaleBehaviour = val.scaleBehaviour || "linear";
      console.log("scaleBehaviuor is", this.scaleBehaviour)
      // value like time value
      this.value = val.value;
    },
    onValueChanged() {
      this.emit();
    },
    emit() {
      this.modelItem.value = {
        scaleBehaviour: this.scaleBehaviour,
        value: this.value
      };
      this.$emit("pick", this.modelItem.value);
    }
  }
};
</script>
